import type { BrandPageFragment } from 'src/types';

const brandLinkClick = (
  brand: Pick<BrandPageFragment, 'id' | 'name' | 'featured'>
) => ({
  type: 'BRAND_LINK_CLICK',
  brand,
});

const brandMediaToggle = (show: boolean) => ({
  type: 'BRAND_MEDIA_TOGGLE',
  show,
});

export default {
  brandLinkClick,
  brandMediaToggle,
};
